<template>
  <div v-loading="loading">
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 上传记录 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="门店仓库">
          <customer-store-select
            :defaultFirst="true"
            style="width: 180px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="上传状态">
          <el-select
            v-model="formInline.optStatus"
            @change="queryClick"
            style="width: 206px"
            placeholder="上传状态"
          >
            <el-option label="全部状态" value=""></el-option>
            <el-option label="待处理的" value="0"></el-option>
            <el-option label="已上传的" value="1"></el-option>
            <el-option label="待查询的" value="2"></el-option>
            <el-option label="上传失败" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经营月份">
          <time-range :cache="false" timeType="month" @change="handleTimeChange" />
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <div v-if="storeInfo">
        <div style="padding: 20px">
          <x-table
            ref="list"
            listApi="biz.warehouse.vet.upload.list"
            paginationLayout="total, sizes, prev, next, jumper"
            actionFixed="right"
            emptyLabel="暂无兽药出入库上传记录信息"
            :fieldList="fieldList"
            :defaultParams="defaultParams"
            :actionWidth="80"
          >
            <template slot="row-info" slot-scope="scope">
              <warehouse-vet-upload :vetUploadInfo="scope.row" />
            </template>
          </x-table>
          <div style="margin-top: 20px">
            <span style="color: #919191">
              <span> * 可登录</span>
              <el-link :underline="false" @click="openEPlatformPageClick">
                国家兽药追溯系统
              </el-link>
              <span>，查询上报状态</span>
            </span>
          </div>
        </div>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="getDetail" size="small"> 重新加载 </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script>
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import warehouseVetUpload from "../../../../components/business/warehouseVetUpload.vue";
import timeRange from "../../../../components/timeRange.vue";

export default {
  components: {
    customerStoreSelect,
    warehouseVetUpload,
    timeRange,
  },
  data() {
    return {
      times: null,
      loading: false,
      errorMsg: null,
      storeGuid: "",
      formInline: {
        optStatus: "",
      },
      queryModel: {},
      storeInfo: null,
      fieldList: [
        {
          label: "上传记录",
          minWidth: "280",
          slot: "info",
        },
      ],
    };
  },
  computed: {
    defaultParams() {
      return Object.assign(
        {
          optCancel: "0",
          storeGuid: this.storeGuid,
        },
        this.times || {},
        this.queryModel || {}
      );
    },
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
      this.fetchStoreInfo();
    },
  },
  methods: {
    clearClick() {
      this.formInline = {
        optStatus: "",
      };
      this.queryModel = {};
    },
    queryClick() {
      this.queryModel = Object.assign({}, this.formInline);
    },
    handleTimeChange(time) {
      this.times = time;
    },
    openEPlatformPageClick() {
      if (!this.storeInfo) {
        return;
      }
      this.openPostPage("http://vdts.ivdc.org.cn:7093/eplatform-sy-org-web/login", {
        userName: this.storeInfo.vetUserid,
        password: this.storeInfo.vetPassword,
        userType: "jingying",
      });
    },
    fetchStoreInfo() {
      if (this.storeGuid) {
        this.errorMsg = null;
        this.loading = true;
        this.requestApi(
          "biz.customer.store.info.detail",
          {
            guid: this.storeGuid,
          },
          {
            cache: 1,
            cacheCallback: (resp) => {
              this.loading = false;
              this.storeInfo = resp.data;
            },
          }
        )
          .then((resp) => {
            this.loading = false;
            this.storeInfo = resp.data;
          })
          .catch((err) => {
            this.loading = false;
            this.errorMsg =
              (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
          });
      } else {
        this.loading = false;
        this.errorMsg = null;
        this.storeInfo = null;
      }
    },
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
    this.fetchStoreInfo();
  },
};
</script>
